import React from 'react';
import PropTypes from 'prop-types';
import MarketShare from 'components/partials/charts/ShareChart';
import { transformPieChartData } from '../ProductionDashboardHelpers';

export default function MachineTab({ machineChecks }) {
  if (!machineChecks?.length) {
    return (
      <div className="p-4 text-center border rounded">
        No machine check data available for this date.
      </div>
    );
  }

  return (
    <div>
      <h3>Machine Performance</h3>
      <div className="charts-grid">
        <MarketShare
          data={transformPieChartData(machineChecks, 'shift')}
          radius={['95%', '83%']}
          title="Machine Checks By Shift"
        />
        <MarketShare
          data={transformPieChartData(machineChecks, 'stationName')}
          radius={['95%', '83%']}
          title="Machine Checks By Station"
        />
        <MarketShare
          data={transformPieChartData(machineChecks, 'machineName')}
          radius={['95%', '83%']}
          title="Machine Checks By Machine"
        />
      </div>
    </div>
  );
}

MachineTab.propTypes = {
  machineChecks: PropTypes.array.isRequired
};
